import { useParams } from 'react-router-dom';
import InfoArteFinalContainer from './ArteFinalInfo/InfoArteFinalContainer';
import InfoArteFinalTitle from './ArteFinalInfo/InfoArteFinalTitle';
import TitleSection from './ArteFinalInfo/TitleSection';
import { isNullOrEmptyString } from '../../../utils/textFunctions';
import { IMPRIMIBLES_LANGUAGES } from '../../../utils/constants';
import ButtonsPdf from './ImprimibleInfo/ButtonsPdf';
import InputPdf from './ImprimibleInfo/InputPdf';
import { useGetPdfLanguages } from '../../../hooks/useArteFinal';
import SkeletonLoader from '../../common/SkeletonLoader';

import ReportProblemIcon from '@mui/icons-material/ReportProblem';

import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: 'orange',
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
  },
  '& .MuiTooltip-tooltip': {
    backgroundColor: 'orange',
    color: 'white',
    fontWeight: 'bold',
    fontSize: '14px',
    padding: '8px 12px',
  },
}));

const ArteFinalDescargable = ({ issue }) => {
  const { idArte } = useParams();
  const { data: pdfLanguages, isLoading } = useGetPdfLanguages(idArte);

  const renderPdfSection = () => {
    if (isLoading) {
      return <SkeletonLoader count={4} minHeight={'100px'} />;
    }

    return IMPRIMIBLES_LANGUAGES.map(({ label, property }) => (
      <InfoArteFinalContainer key={property}>
        <InfoArteFinalTitle>{label}</InfoArteFinalTitle>
        <InputPdf pdf={pdfLanguages.data[property]} language={property} />
        {!isNullOrEmptyString(pdfLanguages.data[property]) && (
          <ButtonsPdf pdfs={pdfLanguages.data} property={property} />
        )}
      </InfoArteFinalContainer>
    ));
  };

  return (
    <div className="imprimibles-section">
      <TitleSection
        title={
          <>
            Ficheros imprimibles
            {issue && (
              <BootstrapTooltip title={issue}>
                <ReportProblemIcon color="warning" />
              </BootstrapTooltip>
            )}
          </>
        }
      />
      <div className="imprimibles-container">{renderPdfSection()}</div>
    </div>
  );
};

export default ArteFinalDescargable;
